import { render, staticRenderFns } from "./ProjectTaskDetailsCard.vue?vue&type=template&id=12774170&"
import script from "./ProjectTaskDetailsCard.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports